import { isAssistantEnabled } from '@agently/api';
import routes from 'routes';

/** The Assistant page is full-screen: no bottom menu and no room reserved for it. */
export const isAssistantPage = (pathname: string) =>
  isAssistantEnabled && pathname.startsWith(routes.assistantPath);
